import * as React from "react"
import type { VariantProps } from "class-variance-authority"
import { Badge, badgeVariants } from "./Badge"

/**
 * Pill — Badge with a pill radius. A thin wrapper so consumers can
 * write `<Pill variant="accent">…</Pill>` without remembering `shape="pill"`.
 */
export interface PillProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    Omit<VariantProps<typeof badgeVariants>, "shape"> {
  icon?: React.ReactNode
}

export const Pill = React.forwardRef<HTMLSpanElement, PillProps>((props, ref) => (
  <Badge ref={ref} shape="pill" {...props} />
))
Pill.displayName = "Pill"
